import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { size, isEmpty } from "lodash";
import { ListLayout } from '../containers/Layout';

import { TableRow, TableCell, TableHead, TableBody, IconButton, Box, Typography, CircularProgress } from '@material-ui/core';
import { AddRounded } from '@material-ui/icons';
import TableFooterPagination from '../../../../commonModules/interface/TableFooterPagination';
import { useFetchTransfers } from '../../../../../../../jsx/hooks/getTransfers';
import { fetchTransferDetails } from '../../../../../../../jsx/actions/transferAction';

const formatNumbers = new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 0 });

const ListSaleItem = (props) => {
    const dispatch = useDispatch();
    const SALES = useSelector((state) => state.inventory.sales.SALES);
    const QUOTES = useSelector((state) => state.inventory.quotes.QUOTES);

    const saleListSource = props.SALES || props.QUOTES || SALES || QUOTES || {};
    const dataview = props.dataview || (props.QUOTES ? "quote" : "vente");
    const fetchTransfers = useFetchTransfers(dataview);

    const [saleList, setSaleList] = useState([[], 0]);
    const [saleDetails, setSaleDetails] = useState({});
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (isEmpty(saleListSource)) {
            fetchTransfers();
        }
    }, []);

    useEffect(() => {
        const fetchSaleProducts = async () => {
            if (isEmpty(saleListSource)) return;

            setLoading(true);
            const saleListArray = !isEmpty(saleListSource) ? Object.values(saleListSource) : [];
            const filteredSales = props.getFilteredList(saleListArray);

            const detailsMap = { ...saleDetails };
            const fetchPromises = [];

            for (const sale of filteredSales) {
                if (sale && sale.id && !detailsMap[sale.id]) {
                    fetchPromises.push(
                        dispatch(fetchTransferDetails(sale.id, "transfer"))
                            .then(details => {
                                if (details) detailsMap[sale.id] = details;
                            })
                            .catch(err => {
                                console.error(`Failed to fetch details for sale ${sale.id}:`, err);
                            })
                    );
                }
            }

            await Promise.all(fetchPromises);
            setSaleDetails(detailsMap);
            setLoading(false);
        };

        fetchSaleProducts();
    }, [props.SALES, props.QUOTES, props.selectShop, props.searchClient, props.searchFacture, props.searchType, props.searchCredit, props.start_date, props.end_date]);

    useEffect(() => {
        const result = displayList();
        setSaleList(result);
    }, [saleDetails, props.searchProduct, props.currentPageProd, props.rowsPerPage]);

    const createSaleList = (list) => {
        const { SALES: SALES_PROP, QUOTES: QUOTES_PROP, SHOPS, CLIENTS, PRODUCTS, AGENTS, rowsPerPage, currentPageProd } = props;
        const salesLookup = SALES_PROP || QUOTES_PROP || {};

        return list.slice((currentPageProd || 0) * (rowsPerPage || 20), (currentPageProd || 0) * (rowsPerPage || 20) + (rowsPerPage || 20)).map(saleItem => {
            const client = CLIENTS[saleItem.sale_item_client_id];
            const shop = SHOPS[saleItem.sale_item_shop];
            const agent = AGENTS && AGENTS[saleItem.sale_item_commercial_id];
            const product = PRODUCTS?.[saleItem.product_id];
            const sale = salesLookup[saleItem.sale_id];

            return (
                <TableRow key={saleItem.id || `${saleItem.sale_id}-${saleItem.product_id}`}>
                    <TableCell>{(new Date(saleItem.sale_item_date)).toLocaleString('fr-FR')}</TableCell>
                    <TableCell>{saleItem.sale_item_nature}</TableCell>
                    <TableCell>{product?.name || ''} - {product?.marque || ''}</TableCell>
                    <TableCell>{saleItem.quantity}</TableCell>
                    <TableCell>{formatNumbers.format((saleItem.price ?? saleItem.price_ht ?? (saleItem.total_ht && saleItem.quantity ? saleItem.total_ht / saleItem.quantity : 0)) || 0)}</TableCell>
                    <TableCell>
                        {shop ? (
                            <a
                                href="#"
                                onClick={(e) => { e.preventDefault(); props.handleSingleShop(shop); }}
                            >
                                {shop.name}
                            </a>
                        ) : (
                            <span>{saleItem.sale_item_shop}</span>
                        )}
                    </TableCell>
                    <TableCell>
                        <IconButton
                            color="secondary"
                            onClick={() => props.handleSingleSale(sale, shop, client, agent)}
                        >
                            <AddRounded />
                        </IconButton>
                    </TableCell>
                </TableRow>
            );
        });
    };

    const filterAll = () => {
        const { searchProduct } = props;

        const saleListArray = !isEmpty(saleListSource) ? Object.values(saleListSource) : [];
        const newList = props.getFilteredList(saleListArray);

        let itemList = [];
        newList.forEach(sale => {
            const details = saleDetails[sale.id];
            if (details && details.products && Array.isArray(details.products)) {
                const saleDate = sale.creation_date || sale.date;
                const saleClientId = sale.client_id || sale.client_ref;
                const itemsWithMeta = details.products.map(item => ({
                    ...item,
                    sale_id: sale.id,
                    sale_item_shop: sale.shop_id,
                    sale_item_client_id: saleClientId,
                    sale_item_commercial_id: sale.commercial_id,
                    sale_item_date: saleDate,
                    sale_item_nature: sale.nature
                }));
                itemList.push(...itemsWithMeta);
            }
        });

        if (!isEmpty(searchProduct)) {
            itemList = itemList.filter(item => props.prodFilter(item.product_id));
        }
        return itemList;
    };

    const displayList = () => {
        let tab = [];
        let rows = 0;

        if (!isEmpty(saleListSource)) {
            const filteredList = filterAll();
            rows = size(filteredList);
            tab = createSaleList(filteredList);
        }
        return [tab, rows];
    };

    return (
        <Box>
            <Box p={1}>
                <Typography variant="h6">Liste des produits vendus</Typography>
                {loading && <CircularProgress size={20} style={{ marginLeft: 10 }} />}
            </Box>
            <ListLayout>
                <TableHead>
                    <TableRow>
                        <TableCell>Date</TableCell>
                        <TableCell>Nature</TableCell>
                        <TableCell>Produit</TableCell>
                        <TableCell>Quantité</TableCell>
                        <TableCell>Prix</TableCell>
                        <TableCell>Shop</TableCell>
                        <TableCell>Détails</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {loading && (
                        <TableRow>
                            <TableCell colSpan={7} align="center">
                                <CircularProgress />
                                <Typography variant="body2">Chargement des produits...</Typography>
                            </TableCell>
                        </TableRow>
                    )}
                    {!loading && saleList[1] !== 0 &&
                        saleList[0]
                    }
                    {!loading && saleList[1] === 0 && (
                        <TableRow>
                            <TableCell colSpan={7} align="center">
                                <div className="text-center">
                                    <h5>Pas encore de Ventes</h5>
                                    Cliquez sur <b className="onglet">"Nouveau"</b> Pour créer une nouvelle Vente
                                </div>
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
                {saleList[1] > 20 && (
                    <TableFooterPagination
                        colSpan={7}
                        count={saleList[1]}
                        onChangePage={props.onChangePage}
                        initialPage={props.currentPageProd || 0}
                        page={props.currentPageProd}
                    />
                )}
            </ListLayout>
        </Box>
    );
};

export default ListSaleItem;
